<script>
export default {
    name: 'IlluMail',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7',
        },

        secondaryColor: {
            type: String,
            default: '#313132',
        },
    },
}
</script>
<template>
    <svg role="img"
        class="base-illu illu-mail"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <g
                transform="translate(9 18)"
                :stroke="secondaryColor"
                class="secondary-color"
            >
                <rect x=".5" y=".5" width="45" height="29" rx="4" />
                <path
                    d="M2 2c1 3.111 2.833 6.222 5.5 9.333C10.167 14.444 12.333 16 14 16M44 2c-1 3.111-2.833 6.222-5.5 9.333C35.833 14.444 33.667 16 32 16M2 28l9-13M44 28l-9-13"
                    stroke-linecap="round"
                />
            </g>
            <path
                d="M32.022 40c.595 0 1.192-.064 1.792-.191.6-.127 1.12-.308 1.558-.543l-.468-1.406c-.868.449-1.829.673-2.882.673-1.063 0-2.002-.237-2.816-.71a4.91 4.91 0 01-1.895-1.973c-.448-.84-.673-1.8-.673-2.88 0-1.06.227-2.008.68-2.843a4.944 4.944 0 011.917-1.964c.824-.474 1.773-.711 2.845-.711 1.073 0 2.022.222 2.846.665a4.761 4.761 0 011.916 1.85c.454.789.68 1.698.68 2.727 0 .866-.095 1.513-.285 1.941-.19.428-.456.642-.797.642-.468 0-.702-.326-.702-.978v-4.952h-1.99v.902c-.536-.673-1.287-1.009-2.253-1.009-.634 0-1.207.163-1.719.49a3.41 3.41 0 00-1.214 1.367c-.297.586-.446 1.25-.446 1.995 0 .754.149 1.424.446 2.01a3.391 3.391 0 001.222 1.367c.517.326 1.087.49 1.711.49 1.141 0 1.975-.444 2.502-1.33.156.438.405.77.746.993.341.224.76.337 1.258.337.605 0 1.131-.169 1.58-.505.449-.336.797-.828 1.046-1.475.249-.647.373-1.419.373-2.315 0-1.274-.293-2.415-.878-3.424a6.251 6.251 0 00-2.45-2.376C34.623 26.288 33.426 26 32.08 26c-1.394 0-2.628.3-3.7.902a6.349 6.349 0 00-2.495 2.491c-.59 1.06-.885 2.252-.885 3.576 0 1.335.293 2.538.878 3.607a6.35 6.35 0 002.472 2.515c1.063.606 2.287.909 3.672.909zm-.03-5c-.6 0-1.082-.18-1.446-.54-.364-.36-.546-.852-.546-1.475 0-.613.182-1.097.546-1.452.364-.355.846-.533 1.446-.533.589 0 1.07.175 1.446.526.375.35.562.837.562 1.46 0 .632-.187 1.126-.562 1.481-.375.355-.857.533-1.446.533z"
                :fill="primaryColor"
                class="primary-color"
            />
        </g>
    </svg>
</template>
